<template>
  <AppLayout title="Movimentações">
    <div class="table-card">
      <table class="table">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Produtos</th>
            <th>Data</th>
            <th>Valor</th>
            <th>Saldo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="movimentacao in lista_movimentacoes" :key="movimentacao.id">
            <td><span class="badge" :class="badgeClass(movimentacao.type)">{{ formaterService.operationType(movimentacao.type) }}</span></td>
            <td>{{ productSummary(movimentacao) }}</td>
            <td>{{ formaterService.dateTime(movimentacao.date) }}</td>
            <td>{{ formaterService.currency(movimentacao.value) }}</td>
            <td>{{ formaterService.currency(movimentacao.balance) }}</td>
            <td style="width:50px">
              <router-link :to="{ name: 'movement-detail', params: { id: movimentacao.id } }" class="btn btn-info btn-sm" title="Ver detalhes">
                <i class="bi bi-info-circle-fill"></i>
              </router-link>
            </td>
          </tr>
          <tr v-if="!lista_movimentacoes.length">
            <td colspan="6" class="text-center text-muted">Nenhuma movimentação registrada.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginação -->
    <nav aria-label="Paginação de movimentações" class="mt-3">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
            <i class="bi bi-chevron-left"></i> Anterior
          </button>
        </li>
        <li class="page-item" v-for="p in pages" :key="p" :class="{ active: p === currentPage }">
          <button class="page-link" @click="changePage(p)">{{ p }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
            Próximo <i class="bi bi-chevron-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  </AppLayout>
</template>
<script>
  import { onMounted, ref, computed } from 'vue';
  import AppLayout from "@/components/AppLayout.vue";
  import { movimentacoes } from "@/models/movimentacoes";
  import formaterService from "@/services/formaterService";

  export default {
    name: 'MovementView',
    components: {
      AppLayout
    },
    setup(props) {

      const Movimentacoes = movimentacoes();
      const lista_movimentacoes = ref([]);

      // Variáveis de paginação
      const currentPage = ref(1);
      const totalPages = ref(1);
      const totalMovimentacoes = ref(0);
      const perPage = ref(15);

      const pages = computed(() => {
        const p = [];
        for (let i = 1; i <= totalPages.value; i++) {
          p.push(i);
        }
        return p;
      });

      function productSummary(movimentacao) {
        const itens = movimentacao.to_operation_products ?? [];
        if (!itens.length) return '-';
        const primeiro = itens[0].product?.name ?? ('Produto #' + itens[0].product_id);
        return itens.length > 1 ? `${primeiro} e mais ${itens.length - 1}` : primeiro;
      }

      function badgeClass(type) {
        switch (type) {
          case 'sell': return 'text-bg-success';
          case 'descart': return 'text-bg-warning';
          case 'replace': return 'text-bg-info';
          default: return 'text-bg-secondary';
        }
      }

      const changePage = (page) => {
        if (page < 1 || page > totalPages.value) return;
        currentPage.value = page;
        refresh(page);
      }

      const refresh = async (page = 1) => {
        const retorno = await Movimentacoes.list(page);
        if (retorno) {
          lista_movimentacoes.value = retorno.data;
          totalPages.value = retorno.pages || 1;
          currentPage.value = retorno.page || 1;
          totalMovimentacoes.value = retorno.total || 0;
          perPage.value = retorno.perPage || 15;
        }
      }

      onMounted(function () {
        refresh();
      });

      return {
        lista_movimentacoes,
        productSummary,
        badgeClass,
        formaterService,
        // Paginação
        currentPage,
        totalPages,
        totalMovimentacoes,
        perPage,
        pages,
        changePage
      }
    },
  }
</script>
